import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from '../../../../../../environments/environment';
import {faPlus, faSpinner, faSmile, faSadTear} from '@fortawesome/free-solid-svg-icons';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {TranslateService} from '@ngx-translate/core';
import {ProjectService} from '../../../../../shared/services/project/project.service';
import {StatesService} from '../../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {ProjectDeviceLocation} from '../../../../../shared/classes/project-device-location/project-device-location';
import {FormControl, FormGroup} from '@angular/forms';
import {ReferentialService} from '../../../../../shared/services/referential/referential.service';
import {map} from 'rxjs/internal/operators';
import {ProjectDeviceLocationAddComponent} from './modals/project-device-location-add/project-device-location-add.component';
import {Subscription} from 'rxjs/index';
import {ModalService} from '../../../../../shared/services/modal/modal.service';

@Component({
    selector: 'app-project-location',
    templateUrl: './project-location.component.html',
    styleUrls: ['./project-location.component.css']
})
export class ProjectLocationComponent implements OnInit, OnDestroy {


    public displayedColumns: string[] = ['id', 'parentName', 'name', 'deviceType', 'deviceAssignedUid', 'active', 'action'];
    public projectLocations: MatTableDataSource<any>;
    public countLocations: number = null;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;
    public showSpinner: boolean = false;
    public faPlus = faPlus;
    public faSpinner = faSpinner;
    public faSmile = faSmile;
    public faSadTear = faSadTear;
    public parentLocations: any[] = [];
    public parentAndChildLocations: any[] = [];
    public deviceTypes = [];
    public unitList = [];
    public locationToDelete: number = null;
    public readModeForLocationName: boolean = true;
    public locationForm: FormGroup = new FormGroup({
        name: new FormControl(''),
        parent: new FormControl('')
    });
    public focusedName: string;
    public activeLocationOnly = true;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input('projectId') projectId: number = null;
    @Input('readOnly') readOnly: boolean;


    private reloadProjectLocation: Subscription;

    constructor(private projectService: ProjectService,
                private statesService: StatesService,
                private toastr: ToastrService,
                private translate: TranslateService,
                private modalService: ModalService,
                private referentialService: ReferentialService) {
    }

    ngOnInit() {
        if (this.readOnly) {
            this.displayedColumns = ['id', 'parentName', 'name', 'deviceType', 'deviceAssignedUid', 'active'];
        }
        this.initUnit();
        this.reloadProjectLocation = this.statesService.reloadProjectLocation
            .subscribe(
                () => this.initUnit()
            );


    }

    ngOnDestroy() {
        this.reloadProjectLocation.unsubscribe();
    }

    openModal(projectDeviceLocation: number) {
        //    alert(projectDeviceLocation)
        const modalRef = this.modalService.openNgbModal(ProjectDeviceLocationAddComponent, {size: 'lg'});
        modalRef.componentInstance.projectDeviceLocation = projectDeviceLocation;
        modalRef.componentInstance.projectId = this.projectId;
    }

    initUnit() {
        this.showSpinner = true;
        this.referentialService.getUnits().subscribe((data: any) => {
            this.unitList = data;
            this.initReferentialData();
        }, error2 => {
            this.showSpinner = false;


        });

    }

    initReferentialData() {
        this.showSpinner = true;
        this.referentialService.getDeviceTypes().pipe(map((data: any) => {
                data.forEach((d) => {
                    d.value = d.id;
                    delete d.id;
                    d.name = d.type;
                    delete d.type;
                });
                return data;
            })
        ).subscribe((data: any) => {
            this.deviceTypes = data;
            this.initList();
        }, error2 => {
            this.showSpinner = false;
        });
    }

    changeLockerValue() {
        this.readModeForLocationName = !this.readModeForLocationName;
    }


    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.projectLocations.filter = filterValue;
    }

    addLocation() {
      if (this.locationForm.value.name && this.locationForm.value.name.trim()) {
            this.showSpinner = true;
            const projectDeviceLocation = new ProjectDeviceLocation();
            projectDeviceLocation.name = this.locationForm.value.name.trim();
            projectDeviceLocation.parent = this.locationForm.value.parent;
            this.projectService.postProjectDeviceLocation(this.projectId, projectDeviceLocation)
                .subscribe(
                    (data: any) => {
                        this.initList();
                        this.toastr.success('Location added to the projects', this.translate.instant('SUCCESS'));
                        this.locationForm.reset();
                        this.showSpinner = false;
                    }
                    ,
                    error2 => {
                        this.showSpinner = false;

                    }
                );
        } else {
            this.toastr.error('Location needs to be named.', this.translate.instant('ERROR'));
        }
    }

    confirmDeleteLocation(id: number) {
        this.locationToDelete = id;
    }


    deleteLocation(id: number) {
        this.showSpinner = true;
        this.projectService.deleteProjectDeviceLocation(id, false)
            .subscribe(
                (data: any) => {
                    this.initList();
                    this.toastr.success('Location removed from the projects', this.translate.instant('SUCCESS'));
                    this.showSpinner = false;
                    this.locationToDelete = null;
                }
                ,
                error2 => {
                    this.showSpinner = false;
                    this.locationToDelete = null;
                }
            );
    }

    deleteDeviceLocation(locationId: number) {
        this.showSpinner = true;
        const projectDeviceLocation = new ProjectDeviceLocation();
        projectDeviceLocation.device = null;
        this.projectService.patchProjectDeviceLocation(locationId, projectDeviceLocation)
            .subscribe(
                (data: any) => {
                    this.showSpinner = false;
                    this.initList();
                    this.toastr.success('Device removed', this.translate.instant('SUCCESS'));

                }
                ,
                error2 => {
                    this.showSpinner = false;
                }
            );
    }

    isDeletable(location: any) {
        return location.children.length === 0;
    }

    deviceCanBeAdded(location: any) {
        return !location.deviceAssigned && location.children.length === 0;
    }

    changeParent(location: any, locationParentId: number) {
        //  alert(locationId + "---" + locationParentId);
        this.showSpinner = true;
        location.locationParentPending = true;
        const projectDeviceLocation = new ProjectDeviceLocation();
        projectDeviceLocation.parent = locationParentId;
        this.projectService.patchProjectDeviceLocation(location.id, projectDeviceLocation)
            .subscribe(
                (data: any) => {
                    delete location.locationParentPending;
                    this.initList();
                    this.toastr.success('Location parent changed', this.translate.instant('SUCCESS'));
                    this.showSpinner = false;
                }
                ,
                error2 => {
                    delete location.locationParentPending;
                    this.showSpinner = false;
                }
            );
    }

    changeLocationName(location: any, name: string) {
        if (name === this.focusedName) {
            return;
        }
        if (name.length) {
            this.showSpinner = true;
            location.locationNamePending = true;
            const projectDeviceLocation = new ProjectDeviceLocation();
            projectDeviceLocation.name = name;
            this.projectService.patchProjectDeviceLocation(location.id, projectDeviceLocation)
                .subscribe(
                    (data: any) => {
                        delete location.locationNamePending;
                        this.initList();
                        this.toastr.success('Location name changed', this.translate.instant('SUCCESS'));
                        this.showSpinner = false;
                    }
                    ,
                    error2 => {
                        delete location.locationNamePending;
                        this.showSpinner = false;
                    }
                );
        } else {
            this.toastr.error('Location name can', this.translate.instant('ERROR'));
        }
    }

    getLengthByPriority(location: any, forDevice: boolean = false) {

        if (location.deviceAssigned && forDevice) {
            if (location.deviceAssigned.length) {
                return location.deviceAssigned.length + 'm';
            }
        }

        if (location.length && !forDevice) {
            return location.length + 'm';
        }

        return null;
    }


    getUnitByPriority(location: any, forDevice: boolean = false) {

        if (location.deviceAssigned && forDevice) {
            if (location.deviceAssigned.unit) {
                return this.translate.instant(location.deviceAssigned.unit.value);
            }
        }

        if (location.unit && !forDevice) {
            return this.translate.instant(location.unit);
        }

        return null;

    }

    getParentLocations(location: any) {
        let parentForThisLoacation: any[] = [];
        if (this.parentLocations) {
            this.parentLocations.forEach(d => {
                if (d.id !== location.id) {
                    parentForThisLoacation.push(d);
                }
            });
        }
        return parentForThisLoacation;
    }

    private initList() {

        if (!isNaN(this.projectId)) {
            this.showSpinner = true;
            this.projectService.getProject(this.projectId, 'locations,devices')
                .subscribe(
                    (data: any) => {
                        this.parentLocations = [];
                        this.parentAndChildLocations = [];
                        data.project_device_locations.forEach(d => {
                            if (!d.parent && !d.device && !d.device_type && !d.unit && !d.length) {
                                this.parentLocations.push(d);
                            }
                            d.parentName = d.parent ? d.parent.name : null;
                            d.parentId = d.parent ? d.parent.id : null;
                            d.deviceType = d.device_type ? d.device_type.type : null;
                            d.deviceAssigned = d.device ? d.device : null;
                            d.deviceAssignedUid = d.device ? d.device.uid : null;
                            d.unit = d.unit ? d.unit.value : null;
                            d.length = d.length ? d.length : null;
                            delete d.device;
                            delete d.parent;
                            delete d.device_type;
                            this.parentAndChildLocations.push(d);
                        });

                        this.countLocations = data.project_device_locations.length;
                        if (this.activeLocationOnly) {
                          this.projectLocations  = new MatTableDataSource(this.parentAndChildLocations.filter(
                            (location) => location.active));
                        } else {
                          this.projectLocations = new MatTableDataSource(this.parentAndChildLocations);
                        }



                        this.projectLocations.filter = null;
                        this.projectLocations.sort = this.sort;
                        this.projectLocations.paginator = this.paginator;
                        this.showSpinner = false;
                    },
                    (error2) => {
                        this.showSpinner = false;
                    }
                );
        } else {
            this.projectId = null;
        }

    }

  activeOrInactiveLocation() {
      this.activeLocationOnly = !this.activeLocationOnly;
      this.initUnit();
  }
  getActiveTextForSlider() {
    let active: string = '';
    let all: string = '';
    this.translate.get('ACTIVE_LOCATIONS_ONLY').subscribe((text: string) => {
      active = text;
    });
    this.translate.get('ALL_LOCATIONS').subscribe((text: string) => {
      all = text;
    });
    return this.activeLocationOnly ? active : all;

  }

}
